<template>
   <div>
      <vx-card>
        <vs-row vs-w="12" vs-type="flex" vs-justify="left">
          <vs-button size="medium" color="warning" icon="edit" class="ml-3" @click="$router.go(-1)">Kembali</vs-button>
          <!--vs-button size="medium" color="success" icon="print" class="ml-3" @click="cetak()">Print</vs-button-->
        </vs-row>
        <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="(dataPatient?(dataPatient.visitNumber+'_'+dataPatient.patient.name):'Kwitansi')"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"

          @progress="onProgress($event)"
          @startPagination="onStartPagination()"
          @hasPaginated="onHasPaginated()"
          @beforeDownload="onBeforeDownload($event)"
          @hasDownloaded="onHasDownloaded()"
          ref="html2Pdf">
          <section slot="pdf-content" class="pdf-content" id="section-to-print">
            <section class="report-info">
              <h4 class="title">KWITANSI PEMERIKSAAN LABORATORIUM PCR</h4>
              <section class="patient-info">
                <table>
                  <tr>
                    <td class="txt">Nama</td>
                    <td class="val">: {{dataPatient.patient?dataPatient.patient.name:''}}</td>
                    <td class="txt">No. Kwitansi</td>
                    <td class="val">: {{dataPatient?dataPatient.visitDate:''}}</td>
                  </tr>
                  <tr>
                    <td class="txt">No. RM/NIK</td>
                    <td class="val">: {{dataPatient.patient?dataPatient.patient.patientNumber:''}}</td>
                    <td class="txt">No. Telp/Whatsapp</td>
                    <td class="val">: {{dataPatient.patient?dataPatient.patient.phoneNumber:''}}</td>
                  </tr>
                  <tr>
                    <td class="txt">Tanggal Lahir/Umur</td>
                    <td class="val">: {{dataPatient.patient.dob | formatDate}} / {{dataPatient.patient.dob | calcAge}} TH</td>
                    <td class="txt">Alamat</td>
                    <td class="val">: {{dataPatient.patient?dataPatient.patient.address:''}}</td>
                  </tr>
                  <tr>
                    <td class="txt">Jenis Kelamin</td>
                    <td class="val">: {{dataPatient.patient.gender?dataPatient.patient.gender.name:''}}</td>
                  </tr>
                </table>
              </section>

              <hr style="margin-top: 20px;"/>
              <div>
                <label style="margin-left:20px"><b>NO</b></label>
                <label style="margin-left:85px"><b>PAKET PEMERIKSAAN/PEMERIKSAAN/LAYANAN</b></label>
                <label style="margin-left:165px"><b>HARGA (Rp)</b></label>
              </div>
              <hr/>

              <section class="test-result">
                  <table style="width: 100%">
                    <tbody>
                      <vs-tr v-for="(tr, indextr) in dataPatient.wrap.prices">
                        <vs-td class="val3">{{indextr + 1}}</vs-td>
                        <vs-td class="val5">{{tr.name}}</vs-td>
                        <vs-td class="val2" style="padding-right: 50px;text-align: right !important; font-weight: bold;">{{tr.price | formatCurrency}}</vs-td>
                      </vs-tr>
                      <vs-tr>
                        <vs-td class="val3">&nbsp;</vs-td>
                        <vs-td class="val5" style="text-align: right !important; font-weight: bold;">Total</vs-td>
                        <vs-td class="val2" style="padding-right: 50px;text-align: right !important; font-weight: bold;">{{this.totprice | formatCurrency}}</vs-td>
                      </vs-tr>
                  </tbody>
                </table>
              </section>
              <section class="footer">
                <div style="display: flex">
                  <div style="margin-left: 450px; width: 400px; display: inline-grid">
                      <label style="margin-top: 50px">Kasir</label>
                      <label style="margin-top: 80px"></label>
                  </div>
                </div>
              </section>
            </section>
          </section>
        </vue-html2pdf>
      </vx-card>
   </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import initialConfig from '@/../initialConfig.js';

export default {
    data() {
      return {
        dataPatient: {},
        progress: 0,
        generatingPdf: false,
        pdfOption: {
          margin: [0, 0, 10, 10],
        },
        kaLab: (initialConfig?initialConfig.kaLab:''),
        nip: (initialConfig?initialConfig.nip:''),
        pdfDownloaded: false,
        html2PdfX: null,
        optionX: {},
        pdfContentX: null,
        totprice: 0,
      };
    },
    methods: {
      printit() {
        window.print();
      },
      async cetak() {
        await this.html2PdfX().set(this.optionX).from(this.pdfContentX).toPdf().save();
      },
      onProgress(progress) {
        this.progress = progress;
        console.log(`PDF generation progress: ${progress}%`);
      },
      onStartPagination(e) {
        console.log(`PDF has started pagination :`+e);
      },
      onHasPaginated(e) {
        console.log(`PDF has paginated :`+e);
      },
      async onBeforeDownload ({ html2pdf, options, pdfContent }) {
        console.log(`PDF onBeforeDownload :`+JSON.stringify(options));
        this.html2PdfX = html2Pdf, this.optionX = options, this.pdfContentX = pdfContent;
          await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
              const totalPages = pdf.internal.getNumberOfPages()
              for (let i = 1; i <= totalPages; i++) {
                  pdf.setPage(i)
                  pdf.setFontSize(10)
                  pdf.setTextColor(150)
                  pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
              }
          }).save()
      },
      onHasDownloaded(blobPdf) {
        this.pdfDownloaded = true;
        console.log(`PDF has downloaded yehey`);
        console.log(blobPdf);
      },
      generatePdf() {
        this.$refs.html2Pdf.generatePdf();
      }
    },
    components: {
        VueHtml2pdf,
    },
    mounted() {
      this.generatePdf();
    },
    created() {
      this.dataPatient = this.$route.params;
      let x = 0;
      if (this.dataPatient.wrap.prices && this.dataPatient.wrap.prices.length > 0) {
        this.dataPatient.wrap.prices.map(function(i){
          x += parseInt(i.price);
        });
      }
      this.totprice = x;
    }

  }
  </script>

  <style lang="scss" scoped>
  .pdf-content {
    width: 800px;
    padding-top: 76px;
    //background-image: url("../assets/images/pages/background_report.png") ;

    /* Full height */
    height: 100%;

    /* Center and scale the image nicely */
    background-repeat: no-repeat;
    background-size: cover;
    .title {
      text-align: center;
      margin-top: 10px;
    }
    label {
      font-size: 10px;
    }
    .report-info {
      padding: 85px 50px 0px 50px;
      .patient-info {
        margin-top: 20px;
        font-size: 10px;
      }
      .patient-info td {
          padding: 0 10px 0 10px;
      }
      .patient-info td.txt {
          width: 150px;
      }
      .patient-info td.val {
          width: 220px;
      }
      .test-result td {
        padding: 0 7px 0 7px;
        text-align: center;
        border-bottom: 1px dotted black;
        font-size: 10px !important;
      }
      .test-result td.val1 {
        width: 4%;
        font-weight: bold;
        text-align: left !important;
        padding-left: 25px !important;
      }
      .test-result td.val2 {
        width: 15%;
      }
      .test-result td.val3 {
        width: 3%;
      }
      .test-result td.val4 {
        width: 15%;
        text-align: left !important;
        padding-left: 25px !important;
      }
      .test-result td.val5 {
        width: 20%;
        text-align: left !important;
        padding-left: 45px !important;
      }
      .footer {
          font-size: 10px;
      }

      .footer td.txt {
          width: 80px;
      }
      .footer td.txt1 {
          width: 60px;
      }
      .footer td.val {
          width: 90px;
      }
      .footer td.val1 {
          width: 150px;
      }
      .user-details {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        .user-name {
          margin-bottom: 10px;
          margin-top: 30px;
          flex-shrink: 0;
        }
        .detail-container {
          font-size: 13px;
          flex-shrink: 0;
          &:not(:last-child) {
            margin-bottom: 10px;
          }
          .detail-label {
            font-weight: 600;
            margin-right: 5px;
            font-size: 13px;
          }
        }
      }
      .request-details {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        .user-name {
          margin-bottom: 10px;
          flex-shrink: 0;
        }
        .detail-container {
          font-size: 13px;
          flex-shrink: 0;
          &:not(:last-child) {
            margin-bottom: 10px;
          }
          .detail-label {
            font-weight: 600;
            margin-right: 5px;
            font-size: 13px;
          }
        }
      }
    }
  }

  @media print {
    body * {
      visibility: hidden;
    }
    #section-to-print, #section-to-print * {
      visibility: visible;
    }
    #section-to-print {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  </style>
